/**
 * MSR Sales History window (MSR plan slice 1, owner decision 8): an MSR sees at most the last 90 days, by
 * EVENT date. The server enforces this too (migration 2026-10-02-060 clamps p_date_from for role msr), using
 * America/Chicago "today", so the UI computes the same floor to keep what it shows consistent with what the
 * server returns.
 */
export function msrHistoryFloor(now: Date = new Date()): string {
  const chicagoToday = new Intl.DateTimeFormat("en-CA", {
    timeZone: "America/Chicago",
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
  }).format(now); // YYYY-MM-DD
  const d = new Date(`${chicagoToday}T12:00:00Z`);
  d.setUTCDate(d.getUTCDate() - 90);
  return d.toISOString().slice(0, 10);
}

/** An MSR's From date may not precede the floor; an empty value means "the floor". */
export function clampMsrFrom(value: string, floor: string): string {
  if (!value || value < floor) {
    return floor;
  }
  return value;
}
